import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { IStatusbarService } from 'vscode/vscode/vs/workbench/services/statusbar/browser/statusbar.service';
import { Action } from 'vscode/vscode/vs/base/common/actions';
import { IWorkbenchLayoutService } from 'vscode/vscode/vs/workbench/services/layout/browser/layoutService.service';
import { KeybindingsRegistry } from 'vscode/vscode/vs/platform/keybinding/common/keybindingsRegistry';
import { Action2, registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { Categories } from 'vscode/vscode/vs/platform/action/common/actionCommonCategories';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import { StatusBarFocused } from 'vscode/vscode/vs/workbench/common/contextkeys';
import { getActiveWindow } from 'vscode/vscode/vs/base/browser/dom';

const _moduleId = "vs/workbench/browser/parts/statusbar/statusbarActions";
class ToggleStatusbarEntryVisibilityAction extends Action {
    constructor(id, label, model) {
        super(id, label, undefined, true);
        this.model = model;
        this.checked = !model.isHidden(id);
    }
    async run() {
        if (this.model.isHidden(this.id)) {
            this.model.show(this.id);
        }
        else {
            this.model.hide(this.id);
        }
    }
}
class HideStatusbarEntryAction extends Action {
    constructor(id, name, model) {
        super(id, ( localizeWithPath(_moduleId, 0, "Hide '{0}'", name)), undefined, true);
        this.model = model;
    }
    async run() {
        this.model.hide(this.id);
    }
}
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: 'workbench.statusBar.focusPrevious',
    weight: 200 ,
    primary: 15 ,
    secondary: [16 ],
    when: StatusBarFocused,
    handler: (accessor) => {
        const statusBarService = accessor.get(IStatusbarService);
        statusBarService.focusPreviousEntry();
    }
});
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: 'workbench.statusBar.focusNext',
    weight: 200 ,
    primary: 17 ,
    secondary: [18 ],
    when: StatusBarFocused,
    handler: (accessor) => {
        const statusBarService = accessor.get(IStatusbarService);
        statusBarService.focusNextEntry();
    }
});
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: 'workbench.statusBar.focusFirst',
    weight: 200 ,
    primary: 14 ,
    when: StatusBarFocused,
    handler: (accessor) => {
        const statusBarService = accessor.get(IStatusbarService);
        statusBarService.focus(false);
        statusBarService.focusNextEntry();
    }
});
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: 'workbench.statusBar.focusLast',
    weight: 200 ,
    primary: 13 ,
    when: StatusBarFocused,
    handler: (accessor) => {
        const statusBarService = accessor.get(IStatusbarService);
        statusBarService.focus(false);
        statusBarService.focusPreviousEntry();
    }
});
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: 'workbench.statusBar.clearFocus',
    weight: 200 ,
    primary: 9 ,
    when: StatusBarFocused,
    handler: (accessor) => {
        const statusBarService = accessor.get(IStatusbarService);
        const editorService = accessor.get(IEditorService);
        if (statusBarService.isEntryFocused()) {
            statusBarService.focus(false);
        }
        else if (editorService.activeEditorPane) {
            editorService.activeEditorPane.focus();
        }
    }
});
class FocusStatusBarAction extends Action2 {
    constructor() {
        super({
            id: 'workbench.action.focusStatusBar',
            title: ( localize2WithPath(_moduleId, 1, 'Focus Status Bar')),
            category: Categories.View,
            f1: true
        });
    }
    async run(accessor) {
        const layoutService = accessor.get(IWorkbenchLayoutService);
        layoutService.focusPart("workbench.parts.statusbar" , getActiveWindow());
    }
}
registerAction2(FocusStatusBarAction);

export { HideStatusbarEntryAction, ToggleStatusbarEntryVisibilityAction };
